<template>
  <div class="dialog">
    <div>{{value}}</div>
  </div>
</template>
<script>
export default {
  name: 'dialog-item',
  props: ['value']
}
</script>
<style lang="scss" scoped>
.dialog {
  position: fixed;
  font-size: 0;
  color: #333;
  display: flex;
  align-items: center;
  text-align: center;
  // height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  div {
    display: inline-block;
    margin: auto;
    font-size: .3rem;
    color: #fff;
    max-width: 4rem;
    padding: .1rem .2rem;
    border-radius: .1rem;
    background: rgba(0, 0, 0, 0.7);
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue